import { Controller } from "../vendor/stimulus.js";

export default class extends Controller {
  connect() {
    this.boundOnLoad = (event) => this.handleLoadEvent(event);

    this.mutationObserver = new MutationObserver((mutations) => this.handleMutations(mutations));

    this.mutationObserver.observe(this.element, {
      attributes: true,
      attributeFilter: ["src"],
      subtree: true,
      childList: true
    });

    this.primeExistingImages();
  }

  disconnect() {
    if (this.mutationObserver) {
      this.mutationObserver.disconnect();
      this.mutationObserver = null;
    }
  }

  primeExistingImages() {
    const images = this.element.querySelectorAll("img");
    images.forEach((img) => {
      img.dataset.lazySrc = img.getAttribute("src") || "";
      const src = img.getAttribute("src") || "";
      // Skip preloaded images and placeholder images (skeleton)
      if (src && !img.classList.contains("img-is-loaded") && !src.includes("placeholder")) {
        this.attachImageHandlers(img);
      }
    });
  }

  handleMutations(mutations) {
    mutations.forEach((mutation) => {
      if (mutation.type === "attributes" && mutation.target.tagName === "IMG" && mutation.attributeName === "src") {
        this.handleSrcChange(mutation.target);
      }
      if (mutation.type === "childList") {
        mutation.addedNodes.forEach((node) => {
          if (node.tagName === "IMG") {
            node.dataset.lazySrc = node.getAttribute("src") || "";
            this.attachImageHandlers(node);
          } else if (node.querySelectorAll) {
            node.querySelectorAll("img").forEach((img) => {
              img.dataset.lazySrc = img.getAttribute("src") || "";
              this.attachImageHandlers(img);
            });
          }
        });
      }
    });
  }

  handleSrcChange(img) {
    if (!img) return;
    const newSrc = img.getAttribute("src") || "";
    const prevSrc = img.dataset.lazySrc || "";
    if (newSrc && newSrc !== prevSrc) {
      img.dataset.lazySrc = newSrc;
      img.classList.remove("lazy-load", "img-is-loaded");
      this.attachImageHandlers(img);
    }
  }

  handleLoadEvent(event) {
    const target = event.target;
    if (target?.tagName === "IMG") {
      this.markImageLoaded(target);
    }
  }

  attachImageHandlers(img) {
    if (!img) return;
    const src = img.getAttribute("src") || "";
    if (src.includes("placeholder")) return;

    img.classList.add("lazy-load");
    img.classList.remove("img-is-loaded");
    img.addEventListener("load", this.boundOnLoad, { once: true });
    if (img.complete && img.naturalWidth > 0) {
      this.markImageLoaded(img);
    }
  }

  markImageLoaded(img) {
    if (!img) return;
    img.classList.remove("img-is-loaded");
    // Force a reflow so the transition will run even for cached images.
    void img.offsetHeight;
    // Random delay between 300-1500ms for staggered fade-in effect
    const delay = Math.random() * 1200 + 300;
    window.setTimeout(() => {
      img.classList.add("img-is-loaded");
    }, delay);
  }
}
